var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPeoples = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 21,
  fill: "none",
  viewBox: "0 0 32 21",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#F9C80E",
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.999 10.128a5.057 5.057 0 1 0 0-10.115 5.057 5.057 0 0 0 0 10.115M7.999 11.814A7.595 7.595 0 0 0 .413 19.4c0 .465.377.843.842.843h13.487a.843.843 0 0 0 .843-.843 7.594 7.594 0 0 0-7.586-7.586"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  fill: "#F9C80E",
  clipPath: "url(#b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.074 12.108a3.886 3.886 0 1 0 0-7.772 3.886 3.886 0 0 0 0 7.772M22.074 13.402a5.835 5.835 0 0 0-5.829 5.829c0 .358.29.648.648.648h10.362c.357 0 .647-.29.647-.648a5.835 5.835 0 0 0-5.828-5.829"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.413.013h20.23v20.23H.413z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M16.245 4.336h15.543v15.543H16.245z"
})))));
export { SvgPeoples as ReactComponent };
export default __webpack_public_path__ + "assets/images/peoples.svg";